export default {
  translation: {
    welcome: 'Welcome to React and react-i18next',
    hello: 'Hello, {{name}}!',
    goodMorning: 'Good morning, {{name}}!',
    goodAfternoon: 'Good afternoon, {{name}}!',
    goodEvening: 'Good evening, {{name}}!',

    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    areYouSure: 'Are you sure?',
    back: 'Back',
    backToHome: 'Back to Home',
    close: 'Close',
    you: 'You',
    save: 'Save',

    home: {
      activeChecklists: 'Active Checklists',
      history: 'History',
      recentTemplates: 'Recent Templates',
    },

    onboarding: {
      heading: 'Get started',
      body: 'Create your first checklist or template to get started.',
    },

    settings: {
      title: 'Settings',
      description: 'Manage your account settings.',
      language: 'Language',
      preferences: 'Preferences',
      profile: 'Profile',
      organization: 'Organization',
    },

    notifications: {
      title: 'Notifications',
      configured: 'Push notifications are enabled for this device.',
      notConfigured: 'Push notifications are not configured for this device.',
      unsupported: 'Push notifications are not supported in this browser.',
      denied: 'Push notifications have been blocked. Please enable them in your browser settings.',
      enable: 'Enable Notifications',
      disable: 'Disable Notifications',
      disableSuccess: 'Push notifications have been disabled.',
      disableError: 'Failed to disable push notifications.',
      enableSuccess: 'Push notifications have been enabled.',
      enableError: 'Failed to enable push notifications.',
    },

    profile: {
      name: 'Name',
      namePlaceholder: 'Enter your name',
      nameDescription: 'Your display name visible to others.',
      email: 'Email',
      emailDescription: 'Your email address cannot be changed here.',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
      updateSuccess: 'Profile updated successfully!',
      updateError: 'Failed to update profile. Please try again.',
    },

    templates: {
      deleteItemConfirmation:
        "Are you sure you want to delete this item? This can't be undone.",
      addTemplate: 'Add Template',
      addTemplateDescription:
        "Add a template to your collection. Click save when you're done.",
      templateName: 'Name',
      createTemplate: 'Create Template',
      addNewItem: 'Add a new Item',

      created: 'Template created successfully!',
      deleted: 'Template deleted successfully!',
      deleteConfirmation:
        'This will delete the template and all its items. This will not affect any checklists created from this template.',

      add: 'Add',

      reorder: 'Reorder',
      reordered: 'Reordered',
    },

    checklists: {
      title: 'Checklists',
      description: 'Manage your checklists.',
      addChecklist: 'Add Checklist',
      addChecklistDescription:
        'Add a checklist to your collection. Click save when you are done.',
      checklistName: 'Name',
      checklistDescription: 'Description',
      checklistDescriptionMedia: 'Description Media',
      createChecklist: 'Create Checklist',
      rerun: 'Rerun',
      completed: 'Completed',
      itemsCompleted: 'items completed',
      itemsSkipped: 'items skipped',

      started: 'Checklist started successfully!',
      deleted: 'Checklist deleted successfully!',
      created: 'Checklist created successfully!',

      deleteConfirmation: 'This will delete the checklist and all its items.',

      finish: 'Finish',
      checklistNotFinished: 'Checklist not finished',
      checklistNotFinishedDescription:
        'You still have items to complete. Are you sure you want to finish the checklist?',

      addNewItem: 'Add a new item',

      addImage: 'Add Image',
      viewImage: 'View Image',
      viewVideo: 'View Video',
      skip: 'Skip',
      unskip: 'Unskip',
      mediaRequired: 'Media required',
      requireMediaProof: 'Require media proof',
      requireMediaProofHelp:
        'Require an image or video before completing this item.',
      requiresMediaToComplete:
        'This item requires media proof - upload an image or video to complete',

      uploadFile: 'Upload file',
      viewFile: 'View file',
      uploadSuccess: 'File uploaded successfully!',
      uploadError: 'An error occurred while uploading the file.',

      add: 'Add',

      assign: 'Assign',
      unassign: 'Unassign',
      assignChecklist: 'Assign Checklist',
      assignChecklistDescription:
        'Assign this checklist to a team member. Assigning it to yourself will hide it from other team members.',

      editItem: 'Edit Item',
      deleteItemTitle: 'Delete Item',
      deleteItemDescription:
        'Are you sure you want to delete this item? This action cannot be undone.',
    },
  },
}
